// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';

// ReactDOM.createRoot(document.getElementById('root')).render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ── Browser Language Detection ──
// 1. Check localStorage first (user's manual choice)
// 2. Fall back to browser language
// 3. Default to English if neither matches Japanese

const detectLanguage = () => {
  // 1. Check localStorage first (user's manual choice)
  const saved = localStorage.getItem('preferredLang');
  if (saved === 'en' || saved === 'jp') return saved;

  // 2. Get browser languages list
  const browserLangs = navigator.languages?.length
    ? navigator.languages
    : [navigator.language || 'en'];

  // 3. Check ONLY the first/primary language
  // If first language starts with 'ja' → JP
  // Everything else → EN (including if 'ja' is 2nd, 3rd in list)
  const primaryLang = browserLangs[0].toLowerCase();
  const isJapanese = primaryLang.startsWith('ja');

  return isJapanese ? 'jp' : 'en';
};

const lang = detectLanguage();

// Redirect at root level BEFORE React mounts
// This ensures no flash or timing issues
if (window.location.pathname === '/' || window.location.pathname === '') {
  window.location.replace(`/${lang}`);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
